"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableUIStatefulColumnsSimple = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
/**
 * @deprecated
 * Use `createTableUIStatefulColumns`
 */
var createTableUIStatefulColumnsSimple = function (props) {
    var columnsRenderMapFnMaybe = props.columnsRenderMap, actionsRender = props.actionsRender, orderCols = props.orderCols, disablePagination = props.disablePagination;
    var useTableUI = function (_a) {
        var on = _a.on, extended = _a.extended, rest = __rest(_a, ["on", "extended"]);
        var columnsRenderMap = react_1.useMemo(function () { return columnsRenderMapFnMaybe(extended || {}); }, [extended]);
        var columns = react_1.useCallback(function () {
            var colsKeys = Object.keys(columnsRenderMap);
            if (orderCols) {
                colsKeys = orderCols(colsKeys);
            }
            var cols = __spreadArray([], colsKeys.map(function (key) { return (__assign(__assign({}, columnsRenderMap[key]), { dataIndex: key })); }));
            if (actionsRender) {
                cols.push({
                    title: "",
                    render: actionsRender === null || actionsRender === void 0 ? void 0 : actionsRender({ on: on }),
                    fixed: "right",
                });
            }
            return cols;
        }, [columnsRenderMap, on])();
        return {
            table: (react_1.default.createElement(antd_1.Table, __assign({ size: "small" }, rest, { columns: columns, pagination: !disablePagination && __assign(__assign({}, rest.pagination), { showQuickJumper: true }) }))),
        };
    };
    return {
        useTableUI: useTableUI,
    };
};
exports.createTableUIStatefulColumnsSimple = createTableUIStatefulColumnsSimple;
